const color = (product) =>
  product.options.find((option) => option.name === "Color")?.values[0];

const isLightColor = (product) =>
  ["white"].includes(color(product).toLowerCase());

const price = (product) => product.priceRange.minVariantPrice.amount;

const compareAtPrice = (product) =>
  product.compareAtPriceRange.minVariantPrice.amount;

const currency = (product) => product.priceRange.minVariantPrice.currencyCode;

const url = (product) => new URL(product.onlineStoreUrl).pathname;

export default function addProductHelpers(product) {
  product.helpers = {
    color: color(product),
    isLightColor: isLightColor(product),
    price: price(product),
    compareAtPrice: compareAtPrice(product),
    currency: currency(product),
    url: url(product),
  };

  return product;
}
